import React from 'react';
import PropTypes from 'prop-types';

import Bool from './bool';
import Enum from './enum';
import { getOption, getOptions } from 'helpers/react_select_helpers';

export const propTypes = {
  admin: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.number,
  liquidContext: PropTypes.object,
  option: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  overridden: PropTypes.bool,
  overrideMode: PropTypes.bool,
  readOnlyOption: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.string]),

  onChange: PropTypes.func.isRequired,
  onOptionChange: PropTypes.func,
  onOptionDelete: PropTypes.func,
  onOverrideDefault: PropTypes.func,
  onUseDefault: PropTypes.func
};

export default function Option(props) {
  switch (props.option.type) {
  case Bool.type:
    return <Bool {...props} />;
  case Enum.type:
    return <Enum {...props} />;
  default:
    return null;
  }
}

function validatePresence(value, label, errors) {
  if (value) {
    return true;
  } else {
    errors.push(`${label} is required`);
  }
}

function validateUniqueness(option, key, label, options, index, errors) {
  const unique = options.every((_option, i) => {
    return _option[key] !== option[key] || i === index;
  });

  if (unique) {
    return true;
  } else {
    errors.push(`${label} must be unique`);
  }
}

export function getErrors(option, options, index) {
  const errors = [];

  validatePresence(option.label, 'Label', errors)
    && validateUniqueness(option, 'label', 'Label', options, index, errors);

  validatePresence(option.id, 'ID', errors)
    && validateUniqueness(option, 'id', 'ID', options, index, errors);

  validatePresence(option.icon, 'Icon', errors);

  if (option.type === Enum.type) {
    if (option.values.length < 2) {
      errors.push('At least two values are required');
    }

    if (option.values.some(value => !value)) {
      errors.push('All values must be present');
    }

    if (option.values.length !== new Set(option.values).size) {
      errors.push('All values must be unique');
    }
  }

  return errors;
}

export function getSelectValue(option, value) {
  if (option.multiselect) {
    return getOptions(Object.keys(value || {}));
  } else {
    return getOption(value);
  }
}

export function parseSelectValue(option, selectOption) {
  if (option.multiselect) {
    return selectOption.map(option => option.value).reduce((value, key) => {
      value[key] = true;
      return value;
    }, {});
  } else {
    return selectOption.value;
  }
}

export function serialize(option) {
  const optionDefault = { ...option.default };
  delete optionDefault.evaluated;

  const hidden = { ...option.hidden };
  delete hidden.evaluated;

  return {
    ...option,
    default: optionDefault,
    hidden
  };
}

export function trimValues(option) {
  let values;
  if (option.values) {
    values = option.values.map(value => value.trim());
  }

  return {
    ...option,
    default: (typeof option.default === 'string' ? option.default.trim() : option.default),
    id: option.id.trim(),
    label: option.label.trim(),
    values
  };
}
